/* eslint-disable react/no-danger */
import * as React from 'react';
import * as styles from './styles.css';
import { IContentBlock } from '../../../../common/repositories/job-vacancies-backend/entities/vacancies/ContentBlock';
import { EAction, IButton } from '../../../../common/repositories/job-vacancies-backend/entities/button/Button';
import { StickyActions } from '@cian/frontend-e2e-deal-component';
import { ICardBanner } from '../../../../common/repositories/job-vacancies-backend/entities/banner/CardBanner';
import { Banner } from '../../../Banner/Banner';
import { Typography } from '../../../../components/Typography';
import { Button } from '../../../../components/Button';
import cn from 'clsx';
import { useDeviceType } from '@cian/ui-kit';

interface IVacancyInfoLayoutProps {
  description?: IContentBlock[];
  banners?: ICardBanner[];
  buttons?: IButton[];
  buttonHandler: (action: EAction) => void;
}

// На бекенде есть санитайзер для устранения возможных проблем с xss-уязвимостями,
// в отдельной задаче необходимо будет дополнительно добавить санитазейр и для фронта

//TODO: Уточнить вопрос насчет фиксированного положения кнопок при скролле в задаче CD-187517
export const VacancyInfoLayout: React.FC<IVacancyInfoLayoutProps> = ({
  banners,
  buttons,
  description,
  buttonHandler,
}) => {
  const deviceType = useDeviceType();
  const isDesktop = useDeviceType() === 'desktop';

  const stickyClassNames = {
    actionArea: cn(styles['action-area'], styles[deviceType]),
    actionAreaWhenStuck: cn(styles['action-area-when-sticky'], styles[deviceType]),
    actionWrapperWhenStuck: cn(styles['action-wrapper-when-sticky'], styles[deviceType]),
  };

  return (
    <div className={cn(styles['container'], styles[deviceType])}>
      <div className={cn(styles['content'], styles[deviceType])}>
        <div className={cn(styles['description'], styles[deviceType])}>
          {description?.map(section => {
            return (
              <div key={section.title} className={cn(styles['section'], styles[deviceType])}>
                <div className={styles['title']}>
                  {isDesktop ? (
                    <Typography.Title level={5}>
                      <p dangerouslySetInnerHTML={{ __html: section.title || '' }}></p>
                    </Typography.Title>
                  ) : (
                    <Typography.Body level={1}>
                      <p dangerouslySetInnerHTML={{ __html: section.title || '' }}></p>
                    </Typography.Body>
                  )}
                </div>
                <div className={styles['text']}>
                  <Typography.Text tag="div" level={isDesktop ? 1 : 3}>
                    <div dangerouslySetInnerHTML={{ __html: section.body || '' }}></div>
                  </Typography.Text>
                </div>
              </div>
            );
          })}
        </div>

        {buttons && (
          <div className={styles['control']}>
            <StickyActions
              stickyClassNames={stickyClassNames}
              position={isDesktop ? 'sticky' : 'fixed'}
              zIndex={isDesktop ? 0 : 10}
            >
              {buttons?.map(button => {
                return (
                  <Button
                    key={button.text}
                    theme={`fill_${button.theme}`}
                    disabled={Boolean(button.disabled)}
                    fullWidth
                    onClick={() => buttonHandler(button.action)}
                  >
                    {button.text}
                  </Button>
                );
              })}
            </StickyActions>
          </div>
        )}
      </div>
      {banners && (
        <div className={styles['banners']}>
          {banners.map((banner, index) => (
            <Banner key={index} content={banner} withMaxWidth={banners?.length > 1 && isDesktop} />
          ))}
        </div>
      )}
    </div>
  );
};
